<template>
  <div class="class-charts">
    <!-- 分类得分情况 -->
    <!-- {{name}}
{{score}} -->

    <div
      class="canvas-box"
      :style="{ height: height + 'px' }"
      ref="behaviorBar"
    ></div>
  </div>
</template>
<script>
export default {
  props: ["model"],
  data() {
    return {
      height: 750,
      name: [],
      score: [],
    };
  },
  mounted() {
    this.renderMap();
  },
  watch: {
    model(val) {
       this.renderMap();
    }
  },
  methods: {
    renderMap() {
      let height = 0;
      this.model.map((item) => {
        this.name.push(item.name);
        this.score.push(item.score);
      });
      let behaviorBar = (window.cc = this.$echarts.init(
        this.$refs["behaviorBar"],
        null,
        {
          renderer: "svg",
        }
      ));
      height = this.score.length * 70 + 25;
      this.height = height;
      let option = {
        height: height,
        grid: {
          top: "0.7%",
          left: "3%",
          right: "11%",
          bottom: "2.5%",
          containLabel: true,
        },
        yAxis: [
          {
            type: "category",
            data: this.name,
            inverse: true,
            axisTick: { show: false }, // 刻度
            axisLabel: {
              margin: 10,
              textStyle: {
                fontSize: 17,
                 fontWeight: "bold",
                color: "black",
              },
            },
            axisLine: {
              lineStyle: {
                color: "#cfe0f4",
                width:2,
              },
            },
          },
        ],
        xAxis: [
          {
            type: "value",
            position: "top",
            max:10,
            axisLabel: {
              margin: 4,
              interval: 2, //横轴信息全部显示
              textStyle: {
               fontSize: 18,
              fontWeight: "bold",
              color: "#29BDB9",
              },
            },
            axisLine: {
              lineStyle: {
              color: '#cfe0f4'
                
              },
            },
            splitLine: {

              lineStyle: {
                 width:2,
                color:  ['#cfe0f4', '#E6EEF9','#E6EEF9','#E6EEF9','#E6EEF9'],
              },
            },
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: 36,
            data: this.score,
            label: {
              normal: {
                show: false,
              },
            },
            itemStyle: {
              normal: {
                color: "#29BDB9",
                // new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                //     offset: 0,
                //     color: '#CFFAF9' // 0% 处的颜色
                // }, {
                //     offset: 1,
                //     color: '#29BDB9' // 100% 处的颜色
                // }], false),
              },
            },
          },
        ],
      };
 
      behaviorBar.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped>
.class-charts {
  position: relative;
  .canvas-box {
    width: 400px;
    overflow: hidden;
     margin: -28.5px auto 20px;
    
    //  margin: -113px 0 0 45px;
    // margin: 10px auto 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dataView/echarts/all/behaviorBar.vue